import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminNavigation from '../../components/AdminNavigation';

// Importando os ícones da biblioteca lucide-react
import {
  ClipboardList,
  Users,
  BookOpen,
  FileText,
  Settings
} from 'lucide-react';

// Ícone do terço (Wikimedia Commons - CC BY-SA 2.5)
const TercoIcon = ({ className }) => (
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/d/d9/Rosary.svg"
    alt="Terço"
    className={className}
    style={{ width: '48px', height: '48px' }}
  />
);

export default function HomeDinamica() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (!userData) {
      navigate('/login');
    } else {
      setUser(JSON.parse(userData));
    }
  }, [navigate]);

  const cards = [
    {
      title: 'Escala',
      description: 'Consulte e preencha sua escala de serviço para as celebrações.',
      button: 'Acessar Escala',
      route: 'escala',
      icon: ClipboardList,
    },
    {
      title: 'Agenda',
      description: 'Confira o calendário com as próximas reuniões e eventos do grupo.',
      button: 'Ver Agenda',
      route: 'reunioes',
      icon: Users,
    },
    {
      title: 'Formação',
      description: 'Acesse os materiais de estudo para aprofundar seu conhecimento.',
      button: 'Ver Formações',
      route: 'formacao',
      icon: BookOpen,
    },
    {
      title: 'Instruções',
      description: 'Leia as orientações e diretrizes importantes para o serviço.',
      button: 'Ver Instruções',
      route: 'instrucoes',
      icon: FileText,
    },
  ];


  if (user?.roles?.includes('coordenador') || user?.roles?.includes('admin')) {
    cards.push({
      title: 'Painel de Coordenação',
      description: 'Gerencie os membros, a agenda e as formações do seu grupo.',
      button: 'Acessar Painel',
      // Adiciona grupo_id na rota para garantir que o painel receba o parâmetro
      route: `coordenacao?grupo_id=${user.grupo_id}`,
      icon: Settings,
    });
  }

  // Exibir card do Terço Diário apenas para administradores
  if (user?.roles?.includes('admin')) {
    cards.push({
      title: 'Terço Diário',
      description: 'Acompanhe e reze o terço diariamente com leituras e reflexões.',
      button: 'Abrir Terço',
      route: 'terco-diario',
      icon: TercoIcon,
    });
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <p className="text-lg text-gray-500">Carregando...</p>
        </div>
      </div>
    );
  }


  const handleNavigate = (route) => {
    if (route.startsWith('/')) {
      navigate(route);
      return;
    }
    
    const slugify = (text) =>
      String(text || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-');

    const destino = `/diocese/${slugify(user.diocese)}/paroquia/${slugify(user.paroquia)}/comunidade/${slugify(user.comunidade)}/tipo/${slugify(user.tipo)}/${route}`;
    navigate(destino);
  };

  // NOVO: Função de logout explícita
  const handleLogout = () => {
    // Limpa todos os dados de autenticação armazenados
    localStorage.clear();
    // Redireciona o usuário para a página de login
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6 md:p-8">
      <AdminNavigation />
      
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-800 tracking-tight">
          Bem-vindo(a), {user.name.split(' ')[0]}
        </h1>
        <p className="text-xl text-gray-600 mt-2">
          {user.tipo} | {user.comunidade}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {cards.map((item) => {
          const IconComponent = item.icon;
          return (
            <div
              key={item.title}
              className="group bg-white rounded-2xl shadow-lg p-6 flex flex-col justify-between transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              <div className="text-center">
                <IconComponent className="w-12 h-12 mx-auto mb-4 text-gray-400 transition-colors duration-300 group-hover:text-green-600" strokeWidth={1.5} />
                <h2 className="text-2xl font-semibold text-gray-900">{item.title}</h2>
                <p className="text-gray-500 text-sm mt-2 h-10">{item.description}</p>
              </div>
              <button
                onClick={() => handleNavigate(item.route)}
                className="mt-6 w-full bg-green-600 text-white font-semibold py-3 px-4 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition"
              >
                {item.button}
              </button>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-12">
        <button
          onClick={handleLogout}
          className="text-sm text-gray-500 hover:text-gray-800 hover:underline"
        >
          Sair da conta
        </button>
      </div>
    </div>
  );
}